import { useLingui } from "@lingui/react/macro"

interface Props {
  className?: string
}

export function XIcon(props: Props) {
  const { t } = useLingui()

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M11.834 2.66663H13.8786L9.41187 7.46731L14.6666 14H10.5522L7.32964 10.0379L3.64231 14H1.59654L6.37412 8.86509L1.33325 2.66663H5.55211L8.46501 6.28806L11.834 2.66663ZM11.1165 12.8492H12.2494L4.93652 3.75695H3.7208L11.1165 12.8492Z"
        fill="currentColor"
      />
    </svg>
  )
}
